module.exports = __webpack_public_path__ + "static/favicon-5a2c3793ac3fd85a8c1989a998f2872a.ico";